import { WireTransferDetails } from './wire-transfer-details/wire-transfer-details'
import { WireTransferUploadSlip } from './wire-transfer-upload-slip/wire-transfer-upload-slip'

export const WireTransferStack = {
  WireTransferDetailsPage: WireTransferDetails,
  WireTransferUploadSlipPage: WireTransferUploadSlip,
}
